import {
  MERGE_CONTACT_REQUEST,
  MERGE_CONTACT_SUCCESS,
  MERGE_CONTACT_FAILURE,
  statusType
} from '../../actions'

const initial = {
  status: statusType.IDLE
}

const merge = (state = initial, action) => {
  const { payload } = action

  switch (action.type) {
    case MERGE_CONTACT_REQUEST:
      return {
        ...initial,
        status: statusType.IN_PROGRESS
      }

    case MERGE_CONTACT_SUCCESS:
      return {
        ...state,
        data: payload,
        status: statusType.SUCCESS
      }

    case MERGE_CONTACT_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    default:
      return state
  }
}

export default merge
